/**
 * @file index.tsx
 *
 * @fileoverview helper functions for organization analytics events.
 */

import {
  DIMENSIONS,
  PAGE_TYPES,
  PageType,
  setEventParams,
} from '~/jobiqo/lib/analytics';
import { ANONYMOUS_USER } from '~/jobiqo/lib/auth';
import { User } from '~/jobiqo/models/user';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { concatArrayItems } from '~/jobiqo/utils/mapper';
import { getCustomOrganizationProfileDimensions } from '~/jobiqo/components/Slots/customAnalyticsDimensions';

/**
 * Returns the dimensions for a given organization profile.
 *
 * @param {OrganizationProfile} organizationProfile
 *   The organization profile to return dimensions for.
 * @param {User} user
 *   Current user.
 * @returns {Object}
 *   The dimensions object for this organization profile.
 */
export const getOrganizationProfileDimensions = (
  organizationProfile: OrganizationProfile,
  user: User | null = null,
  pageType: PageType = PAGE_TYPES.ORGANIZATION_PROFILE,
) =>
  setEventParams({
    [DIMENSIONS.entity_id]: organizationProfile.id,
    [DIMENSIONS.entity_type]: 'node',
    [DIMENSIONS.entity_subtype]: 'organization_profile',
    [DIMENSIONS.organization_name]:
      organizationProfile.organization?.name ?? organizationProfile.name,
    [DIMENSIONS.title]: organizationProfile.name,
    [DIMENSIONS.current_user_id]: user?.id,
    [DIMENSIONS.user_role]:
      concatArrayItems(user?.roles, 'targetId') ?? ANONYMOUS_USER,
    [DIMENSIONS.owner_id]: organizationProfile.ownerId,
    [DIMENSIONS.organization_id]: organizationProfile.organization?.id,
    [DIMENSIONS.page_type]: pageType,
    ...getCustomOrganizationProfileDimensions(organizationProfile),
  });
